const portfolioItems = [
  {
    'title': 'The Wellness Tracker App',
    'url': 'https://wellness-tracker-app.herokuapp.com',
    'repoUrl': 'https://github.com/e-g-jackson/WellnessTracker',
    'img': '/static/imgs/wellnesstracker.JPG',
    'text': 'This MERN stack App allows users to save and track data about their weight over time and food consumption. Also allows users to search for recipe data and save it for later through the food2fork API.',
    'tech': [
      'HTML',
      'CSS',
      'Javascript',
      'jQuery',
      'AJAX',
      'React',
      'Mongo DB',
      'Mongoose',
      'Express.JS',
      'Node.JS',
      'Animate.CSS'
    ]
  }, {
    'title': 'GGtrivia',
    'url': 'https://guarded-crag-98032.herokuapp.com/',
    'repoUrl': 'https://github.com/e-g-jackson/GG_Trivia',
    'img': '/static/imgs/GGTrivia.JPG',
    'text': 'A Trivia game that uses Sequelize to store and retrieve data from a MySQL database. This data includes a question bank, a leaderboard, and a submitted questions table for user-submitted questions pending approval.',
    'tech': [
      'HTML',
      'CSS',
      'Javascript',
      'jQuery',
      'AJAX',
      'Node.JS',
      'Express.JS',
      'MySQL',
      'Animate.CSS'
    ]
  }, {
    'title': 'MongoScraper',
    'url': 'https://stormy-mesa-78779.herokuapp.com/',
    'repoUrl': 'https://github.com/e-g-jackson/HW-MongoScraper',
    'img': '/static/imgs/MongoScraper.JPG',
    'text': 'This is a MERN stack app that scrapes New York Times Opinion Page using Cherio and Axios and stores data in with MongoDB and Mongoose. This app is a good tool for keeping up-to-date on current events, as well fostering discussion on the topics of the day!',
    'tech': [
      'HTML',
      'CSS',
      'Javascript',
      'AJAX',
      'jQuery',
      'Node.JS',
      'Cheerio'
    ]
  }, {
    'title': 'The Tranzpozer App',
    'url': 'https://tranzpozer.herokuapp.com/',
    'repoUrl': 'https://github.com/e-g-jackson/Tranzpozer',
    'img': '/static/imgs/tranzpozer.JPG',
    'text': 'App will accept a key and scale from the user, then return a table with every note of that scale in the selected key. Additionally, the app will render a diagram of a guitar fret and plot the locations of each of the notes.',
    'tech': [
      'HTML',
      'CSS',
      'Javascript',
      'React',
      'jQuery',
      'axios'
    ]
  }, {
    'title': 'The Clicky Memory Game',
    'url': 'https://theclickymemorygame.herokuapp.com/',
    'repoUrl': 'https://github.com/e-g-jackson/HW-ClickyGame',
    'img': '/static/imgs/clickygame.JPG',
    'text': 'A Memory game powered by React! Try and click all 12 of the tiles without repeating yourself! Beware: the tiles will re-shuffle themselves after every guess!',
    'tech': [
      'HTML',
      'CSS',
      'Javascript',
      'jQuery',
      'Bootstrap',
      'React'
    ]
  }, {
    'title': 'Batman RPG',
    'url': 'https://e-g-jackson.github.io/HW-unit-4-game/',
    'repoUrl': 'https://github.com/e-g-jackson/HW-unit-4-game',
    'img': '/static/imgs/batmanrpg.JPG',
    'text': 'An RPG set in the DC universe! Pick your favorite hero (or villain!) and decide who rules the streets of Gotham city once and for all!',
    'tech': [
      'HTML',
      'CSS',
      'Javascript',
      'jQuery',
      'bootstrap'
    ]
  }, {
    'title': 'GifTastic',
    'url': 'https://e-g-jackson.github.io/HW-GifTastic/',
    'repoUrl': 'https://github.com/e-g-jackson/HW-GifTastic',
    'img': '/static/imgs/giftastic.JPG',
    'text': 'This site references the Giphy API for gifs based on keyword searches activated by buttons. This app also allows for new buttons, which can be created using the search bar and button. If you\'ve ever struggled to find just the right gif for any situation, this app is for you!',
    'tech': [
      'HTML',
      'CSS',
      'Javascript',
      'bootstrap',
      'AJAX'
    ]
  }, {
    'title': 'Word Guess Game',
    'url': 'https://e-g-jackson.github.io/HW-Word_Guess_Game/',
    'repoUrl': 'https://github.com/e-g-jackson/HW-Word_Guess_Game',
    'img': '/static/imgs/wordguessgame.JPG',
    'text': 'A new twist on an old game: this Hangman-style letter guessing game has an Architecture theme! Find out how well you know the top architects of the 20th century.',
    'tech': [
      'HTML',
      'CSS',
      'Javascript'
    ]
  }, {
    'title': 'Trivia Game',
    'url': 'https://e-g-jackson.github.io/HW-Trivia-Game/',
    'repoUrl': 'https://github.com/e-g-jackson/HW-Trivia-Game',
    'img': '/static/imgs/triviagame.JPG',
    'text': 'Trivia game set in the Game of Thrones universe! Can you match all of the sigils of the great houses to their owners? Just remember, there is a time-limit!',
    'tech': [
      'HTML',
      'CSS',
      'Javascript',
      'Bootstrap'
    ]
  }
]

export default portfolioItems



// WEBPACK FOOTER //
// ./src/assets/portfolioItems.js